module.exports = __webpack_public_path__ + "images/placeholder-project-statistic-desktop-7cbf23c8a7eed5d55b44ffbfc9858370.png";